import React from 'react';
import { observer } from 'mobx-react';
import useStores from '../../hooks/useStores';
import Header from '../@common/Header';

import { DEFAULT_PAGE } from '../../constants';
import * as S from './styles';

function Layout({ children }) {
  const { AppHandler } = useStores();

  const onClickPreviousButton = () => AppHandler.setAppLocation(DEFAULT_PAGE);

  return (
    <S.Container>
      <Header
        onClickPreviousButton={AppHandler.page !== DEFAULT_PAGE ? onClickPreviousButton : null}
      />
      <div className="layout-content">{children}</div>
    </S.Container>
  );
}

export default observer(Layout);
